import React from "react";
import "./contact.scss";

export const Contact = () => {
  return (
    <section id="contact">
      <div className="parent contact-father">
        <div className="container contact">
          <div className="contact-header">
            <h1 data-aos="fade-up">/Contact</h1>
          </div>
          <div className="contact-description">
            <div className="row">
              <div className="title">
                <h2 data-aos="fade-up">Keep in Touch</h2>
              </div>
            </div>
            <div className="row">
              {/* <div className="get-touch">
                <p data-aos="fade-up">Get in Touch</p>
              </div> */}
            </div>
            <div className="row">
              <div className="statement">
                <p data-aos="fade-up">
                  If you have any questions, feedback, or just want to say hi, 
                  I’ll be happy to hear from you and will get back to you as soon as possible!
                </p>
              </div>
            </div>
            <div className="row">
              <div className="hello-button">
                <a href="mailto:sofiawko@gmail.com">
                  <button
                    className="btn btn-outline-primary"
                    data-aos="fade-up"
                  >
                    Say Hi!
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
